<template>
  <div class="usageHistoryTableRoot">
    <div class="tableMenu">
      <b-select
        v-model="selectedYear"
        @input="handleOnChange"
        placeholder="年"
        icon="file"
        icon-pack="fas">
        <option :value="year"
          v-for="year in years"
          :key="year" >
          {{ year }}年
        </option>
      </b-select>
    </div>
    <b-table
      :data="data"
      detailed
      detail-key="number"
      style="padding-top: 16px;">

      <template slot-scope="props">
        <b-table-column field="account_name" label="プラン名" sortable>
          {{ props.row.account_name }}
        </b-table-column>

        <b-table-column field="period_start" label="開始日" sortable>
          {{ props.row.period_start | dateFormat}}
        </b-table-column>

        <b-table-column field="period_end" label="終了日" sortable>
          {{ props.row.period_end | dateFormat}}
        </b-table-column>

        <b-table-column field="status" label="ステータス" sortable>
          {{ props.row.status | convertStatus }}
        </b-table-column>

        <b-table-column field="hosted_invoice_url" label="請求書URL">
          <a target="_blank" :href="props.row.hosted_invoice_url">ダウンロード</a>
        </b-table-column>

        <b-table-column field="invoice_pdf" label="請求書PDF">
          <a target="_blank" :href="props.row.invoice_pdf">ダウンロード</a>
        </b-table-column>
      </template>

      <template slot="detail" slot-scope="props">
        <div style="display: flex; flex-direction: row">
          <div>
            <display-key-value label="請求書番号:" :text="props.row.number" width="150px" weight="" />
            <display-key-value label="請求金額:" :text="props.row.amount_due + '円'"  width="150px" weight=""/>
            <display-key-value label="作成日:" :text="props.row.created | dateFormat"  width="150px" weight=""/>
          </div>
          <div>
            <display-key-value label="お支払日:" :text="props.row.status_transitions.paid_at | dateFormat"  width="150px" weight=""/>
            <display-key-value label="お支期日:" :text="props.row.due_date | dateFormat"  width="150px" weight=""/>
            <display-key-value label="お支払い方法:" :text="props.row.billing | covertBilling"  width="150px" weight=""/>
          </div>
        </div>
      </template>


      <template slot="empty">
        <b-message type="is-info" has-icon>
          条件に合致する結果はありませんでした。
        </b-message>
      </template>
      
    </b-table>
  </div>
</template>

<script >
import Vue from "vue";
import moment from "moment-timezone";
import DisplayKeyValue from "@/components/molecules/DisplayKeyValue";

export default Vue.extend({
  components: { DisplayKeyValue },
  data() {
    return {
      selectedYear: (new Date()).getFullYear().toString(),
      rows: [],
    };
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    years() {
      const year = new Date().getFullYear();
      const options = [];
      for (let i = 4; i >= 0; i--) {
        options.push(year - i);
      }
      console.log(options);
      return options;
    },
  },
  methods: {
    handleOnChange(val) {
      console.log(val);
      this.$emit("selectedYearChange", val);
    },
  },
  filters: {
    dateFormat(value) {
      if (!value) {
        return "";
      }
      return moment.utc(value * 1000).tz("Asia/Tokyo").format("YYYY/MM/DD");
    },
    // TODP: pattern https://stripe.com/docs/billing/invoices/workflow#workflow-overview
    convertStatus(value) {
      const status = {
        draft: "未確定",
        open: "確定",
        paid: "支払い済み",
        void: "誤り",
      };
      const s = status[value];
      return s ? s : "その他";
    },
    covertBilling(value) {
      return value === "charge_automatically" ? "クレジットカード(自動引落し)" : "メールによる請求書の送付";
    },
  },
});
</script>

<style lang="scss" scoped>
.usageHistoryTableRoot {
  & .tableMenu {
    @media screen and (min-width: 1024px) {
      display: flex;
    }
  }
  & .dateRange {
    margin-left: 16px;

    @media screen and (max-width: 768px) {
      margin: 16px 0px;
    }
  }
}
</style>
